import { axiosGet, axiosPost,axiosPut, axiosDelete } from "../options/header"
export default {
  getAll(accessToken,page, broj_projekta, start_date, end_date, isArchived, id_person) {
    try {
      return axiosGet(process.env.VUE_APP_API_ENDPOINT_STARTER + "/projects", {
        params: {
          
          page,
          broj_projekta,
          start_date,
          end_date,
          isArchived,
          id_person
        },
         credentials: true
      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  searchProjects(srch_txt) {
    try {
      return axiosGet(process.env.VUE_APP_API_ENDPOINT_STARTER + "/projects/search", {
        params: {
          srch_txt
        },
         credentials: true
      });
    } catch {
      console.log("Failed attempt at search.");
    }
  },
  getAllFilteri() {
    try {
      return axiosGet(process.env.VUE_APP_API_ENDPOINT_STARTER + "/predmeti/filteri", {
        params: {},
         credentials: true
      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  getAllPhases() {
    try {
      return axiosGet(process.env.VUE_APP_API_ENDPOINT_STARTER + "/predmeti/filteri/faze", {
        params: {},
         credentials: true
      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  getCaseTeam(predmetId) {
    try {
      return axiosGet(process.env.VUE_APP_API_ENDPOINT_STARTER + "/predmeti/"+predmetId+"/team", {
         credentials: true
      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  getCaseTeamShort(predmetId) {
    try {
      return axiosGet(process.env.VUE_APP_API_ENDPOINT_STARTER + "/predmeti/"+predmetId+"/team_short", {
         credentials: true
      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  getAllPostupci() {
    try {
      return axiosGet(process.env.VUE_APP_API_ENDPOINT_STARTER + "/predmeti/postupci", {
        params: {},
         credentials: true
      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  getAllBrojevi() {
    try {
      return axiosGet(process.env.VUE_APP_API_ENDPOINT_STARTER + "/projects/next-num", {
         credentials: true
      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  getUserProjectPermission(projectId, user_id) {
    try {
      return axiosGet(process.env.VUE_APP_API_ENDPOINT_STARTER + "/projects/"+projectId+"/permissions", {
        params: {
          user_id : user_id
        },
         credentials: true
      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },

  getSingle(predmetId, logged_uid) {
    try {
      return axiosGet(process.env.VUE_APP_API_ENDPOINT_STARTER + "/projects/"+predmetId, {
        params: {
          logged_uid,
        },
         credentials: true
      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  addProject(unos_projekta, access_token,logged_uid) {
    try {
      return axiosPost(process.env.VUE_APP_API_ENDPOINT_STARTER + "/projects/", {
        params: {
          unos_projekta,
          access_token,
          logged_uid
        },
         credentials: true
      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  updateProject(unos_projekta, access_token,project_id, logged_uid) {
    try {
      return axiosPut(process.env.VUE_APP_API_ENDPOINT_STARTER + "/projects/"+project_id, {
        params: {
          unos_projekta,
          access_token,
          logged_uid
        },
         credentials: true
      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },


  // NAPOMENE START
  addPredmetNapomena(napomena,group_url) {
    try {
      return axiosPost(process.env.VUE_APP_API_ENDPOINT_STARTER + "/predmeti/"+group_url+"/napomene", {
        params: {
          napomena
        },
         credentials: true
      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  getPredmetNapomene(group_url) {
    try {
      return axiosGet(process.env.VUE_APP_API_ENDPOINT_STARTER + "/predmeti/"+group_url+"/napomene");
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  addNewProjectTask(params) {
    try {
      return axiosPost(process.env.VUE_APP_API_ENDPOINT_STARTER + "/projects/project-task", params , {
         credentials: true
      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  updateProjectTask(params) {
    try {
      return axiosPost(process.env.VUE_APP_API_ENDPOINT_STARTER + "/projects/update-project-task", params, {
         credentials: true
      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  updateProjectProgress(event_uid, status_id, team_list, case_uid, is_case) {
    try {
      return axiosPost(process.env.VUE_APP_API_ENDPOINT_STARTER + "/projects/update-status", {
        params: {
          event_uid,
          status_id,
          team_list,
          case_uid,
          is_case,
        },
         credentials: true
      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  getProjectTasks(group_url) {
    try {
      return axiosGet(process.env.VUE_APP_API_ENDPOINT_STARTER + "/projects/"+group_url+"/tasks");
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  deleteTask(access_token, task_uid, team_list, case_uid, attachments, group_uid, is_case) {
    try {
      return axiosDelete(process.env.VUE_APP_API_ENDPOINT_STARTER + "/projects/project-task/", {
        params: {
          task_uid,
          access_token,
          team_list,
          case_uid,
          attachments,
          group_uid,
          is_case,
        },
         credentials: true
      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  getTaskAttachment(group_url,attachment_id){
    try {
      return axiosGet(process.env.VUE_APP_API_ENDPOINT_STARTER + "/projects/task-attachment/existing-attachment", {
        params: {
          
          group_url : group_url,
          attachment_id : attachment_id,
        },
         credentials: true
      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  // NAPOMENE END


  // MESSAGES START
  
  get_project_messages(group_url){
    try {
      return axiosGet(process.env.VUE_APP_API_ENDPOINT_STARTER + "/projects/"+group_url+"/messages", {
        params: {
          group_url : group_url,
        },
         credentials: true
      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  send_project_message(group_url, new_message, list_of_users){
    try {
      return axiosPost(process.env.VUE_APP_API_ENDPOINT_STARTER + "/projects/"+group_url+"/messages", {
        params: {
          new_message,
          list_of_users
        },
         credentials: true
      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  // MESSAGES END
  openProject(proj_id) {
    try {
      return axiosPost(process.env.VUE_APP_API_ENDPOINT_STARTER + "/projects/"+proj_id+"/open", {
         credentials: true
      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  closeProject(proj_id, datum_arhiviranja) {
    try {
      return axiosPost(process.env.VUE_APP_API_ENDPOINT_STARTER + "/projects/"+proj_id+"/close", {
        params:{
          datum_arhiviranja
        },
         credentials: true
      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
};
